module.exports = __webpack_public_path__ + "img/g矩形 85@1x.204a35a4.png";